import initialState from '../../initialState';

export const transformPaginationForFeed = (pagination = initialState.pagination) => ({
  currentPage: pagination.current_page,
  perPage: pagination.per_page,
  totalPages: pagination.total_pages,
  totalCount: pagination.total_count,
});
